import FineService from './../../../../service/fine';
import ValidateService from './../../../../service/validate';
import { FORM_FIELD } from './../../core/abstract';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import { connect } from 'react-redux';
import SearchPrompt from './../../core/search';
import PayFineTypeEnum from './../../core/enum/pay-fine-type';
import { Header, AdminSearchFineViewPrompt } from './view';
import theme from './../../../theme';

class _AdminSearchFinePrompt extends SearchPrompt 
{
    constructor(parms)
    {
        super(parms, _AdminSearchFinePrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.onSearchResponse = this.onSearchResponse.bind(this);
        this.onSearchError = this.onSearchError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getSearchResultUi = this.getSearchResultUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.getSearchResultsUi = this.getSearchResultsUi.bind(this);
        this.getNoResultsUi = this.getNoResultsUi.bind(this);
    }

    static getValidators()
    {
        return {
            type: {
                isValid: ValidateService.anyValue
            }
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            type: {
                name: 'Fine Type',
                error: '',
                value: PayFineTypeEnum.PAY_FINE_TYPE_DISPUTE,
                valueList: PayFineTypeEnum.getDropDownValues(),
                visible: true,
                touched: false,
                type: FORM_FIELD.DROP
            }
        };
    }

    onSearchResponse(response)
    {
        super.onSearchResponse(response, 'fineList');
    }

    onSendToServer(request = undefined)
    {
        FineService.adminSearch({
            request: request ? request : this.getServerRequest(),
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getServerRequest()
    {
        return {
            page: 0,
            type: this.state.type.value,
            targetUserId: this.props.userId ? this.props.userId : undefined
        };
    }

    onLoadSpecifiedPage(page)
    {
        this.setContactingServer(true);
        let request = this.getServerRequest();
        request.page = page;
        this.onSendToServer(request);
    }

    getNoResultsUi()
    {
        return (
            <div style={{
                ...theme.getGeneralTextStyle(theme)
            }}>
                <p>
                    No Fees Found.
                </p>
            </div>
        );
    }

    getSearchResultUi(aResult, index)
    {
        return <AdminSearchFineViewPrompt fineRecord={aResult} key={index} />
    }

    getSearchResultsUi()
    {
        return this.state.results.length < 1 ? this.getNoResultsUi() : 
            <div>
                <table>
                    <Header />
                    <tbody>
                        {  this.state.results.map((aResult, index) => this.getSearchResultUi(aResult, index)) }
                    </tbody>
                </table>
            </div>
    }
}

const AdminSearchFinePrompt = connect(mapStateToProps, mapDispatchToProps)(_AdminSearchFinePrompt);
export default AdminSearchFinePrompt;
